import React from 'react';
import { IconProps } from '.';

const SvgCellphone = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M14 17h-4v1.5h4V17Z' />
      <path fill={color} fillRule='evenodd' d='M5 22V2h14v20H5ZM6.5 3.5h11v17h-11v-17Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgCellphone;
